export default Object.freeze({
	PEDIDO_UTILIZACAO: { value: 'PEDIDO_UTILIZACAO', text: 'Pedido de Utilização' },
})
